import { ApiTalentDashboardDto } from "../api/talentDashboard";
import { TalentDashboardDto } from "../app/talentDashboard";

export const mapFromApiTalentDashboard = (apiDto: ApiTalentDashboardDto): TalentDashboardDto => ({
    ...apiDto,
});